import React, { useState, useEffect } from "react";
import { FaUser, FaEnvelope, FaCheck, FaExclamationCircle, FaInfoCircle } from "react-icons/fa";
import { apiService } from "../../../components/Config/api.service";

const User = () => {
    const [user, setUser] = useState({ username: "", email: "" });
    const [userLoading, setUserLoading] = useState(false);
    const [userMsg, setUserMsg] = useState({ type: "", text: "" });
    const [initialEmail, setInitialEmail] = useState("");

    useEffect(() => {
        apiService.getElement("/user")
            .then((res) => {
                setUser({
                    username: res.data.user?.name || "",
                    email: res.data.user?.email || "",
                });
                setInitialEmail(res.data.user?.email || "");
            })
            .catch(() => setUserMsg({ type: "error", text: "Erreur lors du chargement." }));
    }, []);

    const handleUserChange = (e) => {
        setUser({ ...user, [e.target.name]: e.target.value });
    };

    const handleUserSave = async (e) => {
        e.preventDefault();
        setUserLoading(true);
        setUserMsg({ type: "", text: "" });
        try {
            await apiService.saveElement("/user/update", user);
            setUserMsg({ type: "success", text: "Profil mis à jour !" });
            if (user.email !== initialEmail) {
                setTimeout(() => {
                    window.location.href = "/deconnexion";
                }, 500);
            }
        } catch {
            setUserMsg({ type: "error", text: "Erreur lors de la mise à jour." });
        }
        setUserLoading(false);
    };

    return (
        <form onSubmit={handleUserSave} className="space-y-8">
            {/* Section Informations personnelles */}
            <div className="space-y-6">
                {/* <div className="flex items-center gap-3 mb-6">
                    <div className="bg-[--color-primary] rounded-full p-2">
                        <FaUser className="text-[--color-primary]" size={16} />
                    </div>
                    <h4 className="text-lg font-semibold text-gray-800">Informations personnelles</h4>
                </div> */}

                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <div>
                        <label htmlFor="username" className="block text-sm font-medium text-gray-700 mb-2">
                            Nom d'utilisateur *
                        </label>
                        <div className="relative">
                            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                                <FaUser className="h-4 w-4 text-gray-400" />
                            </div>
                            <input
                                id="username"
                                name="username"
                                value={user.username}
                                onChange={handleUserChange}
                                className="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[--color-primary] focus:border-[--color-primary] transition-colors duration-200"
                                placeholder="Votre nom d'utilisateur"
                                required
                            />
                        </div>
                    </div>

                    <div>
                        <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-2">
                            Adresse Email *
                        </label>
                        <div className="relative">
                            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                                <FaEnvelope className="h-4 w-4 text-gray-400" />
                            </div>
                            <input
                                id="email"
                                name="email"
                                type="email"
                                value={user.email}
                                onChange={handleUserChange}
                                className="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[--color-primary] focus:border-[--color-primary] transition-colors duration-200"
                                placeholder="votre@email.com"
                                required
                            />
                        </div>
                        {user.email !== initialEmail && (
                            <div className="mt-2 flex items-start gap-2 p-3 bg-amber-50 border border-amber-200 rounded-lg">
                                <FaInfoCircle className="text-amber-600 mt-0.5 flex-shrink-0" size={14} />
                                <p className="text-xs text-amber-800">
                                    Si vous modifiez votre adresse email, vous serez déconnecté et devrez vous reconnecter avec la nouvelle adresse.
                                </p>
                            </div>
                        )}
                    </div>
                </div>
            </div>

            {/* Message de statut */}
            {userMsg.text && (
                <div className={`flex items-center gap-3 p-4 rounded-lg border ${
                    userMsg.type === "success" 
                        ? "bg-green-50 border-green-200 text-green-800" 
                        : "bg-red-50 border-red-200 text-red-800"
                }`}>
                    {userMsg.type === "success" ? (
                        <FaCheck className="text-green-600" size={16} />
                    ) : (
                        <FaExclamationCircle className="text-red-600" size={16} />
                    )}
                    <span className="font-medium">{userMsg.text}</span>
                </div>
            )}

            {/* Bouton de sauvegarde */}
            <div className="flex justify-end pt-6 border-t border-gray-200">
                <button
                    type="submit"
                    className="flex items-center gap-2 px-6 py-3 bg-[--color-primary] text-white rounded-lg hover:bg-[--color-primary] disabled:opacity-50 disabled:cursor-not-allowed transition-colors duration-200"
                    disabled={userLoading}
                >
                    {userLoading ? (
                        <>
                            <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white"></div>
                            Enregistrement...
                        </>
                    ) : (
                        <>
                            <FaCheck size={16} />
                            Enregistrer les modifications
                        </>
                    )}
                </button>
            </div>
        </form>
    );
};

export default User;